
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/package-details/[...id]",
      function () {
        return require("private-next-pages/package-details/[...id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/package-details/[...id]"])
      });
    }
  